import { InteractionTypes } from '@/entities/interaction';
import { InteractionList } from '@/widgets/interaction-list';

export default function MeetRefusedPage() {
  return (
    <InteractionList
      type={InteractionTypes.MEET_REFUSE}
      direction="bidirectional"
      title="Rendez-vous refusés"
      emptyMessage="Aucun rendez-vous refusé pour le moment."
    />
  );
}
